import { motion } from "framer-motion";
import SectionHeading from "../../components/ui/SectionHeading";
import ScrollReveal from "../../components/animations/ScrollReveal";

const values = [
  {
    title: "Strategic",
    desc: "Data-driven and insight-led strategies for lasting impact. We plan before we execute.",
  },
  {
    title: "Premium",
    desc: "Every touchpoint reflects quality and attention to detail. We never cut corners.",
  },
  {
    title: "Partnership",
    desc: "We work alongside you as an extension of your team, invested in your success.",
  },
];

export default function ValuesPreview() {
  return (
    <section className="py-20 md:py-28 bg-gold-light/10 border-y border-gold-muted/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="What We Stand For"
          title="Our core values"
          subtitle="The principles that guide every project and partnership."
        />
        <div className="mt-16 grid md:grid-cols-3 gap-8 md:gap-12">
          {values.map((item, i) => (
            <ScrollReveal key={item.title} delay={i * 0.1}>
              <div className="border-l-2 border-gold-primary pl-6 py-2">
                <h3 className="font-serif text-xl font-semibold text-aura-text">
                  {item.title}
                </h3>
                <p className="mt-2 font-sans text-aura-text leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
